/**
 * Catalogo di testo italiano per la funzionalità `auth` (accesso, registrazione,
 * verifica di magic-link, ripristino / impostazione password). Le chiavi mappano 1:1
 * alle chiamate `t('auth.*')` in `packages/@gamecodex/world-ui/src/features/auth/*`.
 * I valori sono le stringhe italiane esatte.
 */
export const authIt = {
  // ── AuthShell ────────────────────────────────────────────────────────────
  'auth.shell.homeAriaLabel': 'Home di Grymwyrd',
  'auth.shell.logoAlt': 'Grymwyrd',

  // ── OAuthButtons ─────────────────────────────────────────────────────────
  'auth.oauth.continueWithGoogle': 'Continua con Google',
  'auth.oauth.continueWithDiscord': 'Continua con Discord',

  // ── AccountVerifyPage ────────────────────────────────────────────────────
  'auth.verify.seoTitle': 'Accesso in corso',
  'auth.verify.seoDescription': 'Verifica del tuo link di accesso a Grymwyrd.',
  'auth.verify.errorMissingToken':
    'Questo link di accesso non contiene il token. Richiedi un nuovo link dalla pagina di accesso.',
  'auth.verify.errorInvalidOrExpired':
    'Questo link di accesso non è valido o è scaduto. Richiedi un nuovo link dalla pagina di accesso.',
  'auth.verify.confirming': 'Conferma dell\'accesso in corso…',
  'auth.verify.signedInHeading': 'Sei collegato',
  'auth.verify.signedInAsPrefix': 'Collegato come',
  'auth.verify.signedInAsSuffix': '. Ti stiamo portando al tuo santuario…',
  'auth.verify.takingYouToSanctum': 'Ti stiamo portando al tuo santuario…',
  'auth.verify.goNow': 'Vai ora',
  'auth.verify.problemHeading': 'Problema con il link di accesso',
  'auth.verify.backToSignIn': 'Torna all\'accesso',

  // ── LoginPage ────────────────────────────────────────────────────────────
  'auth.login.errorEnterEmailFirst': 'Inserisci la tua email qui sopra, quindi richiedi un link.',
  'auth.login.seoTitle': 'Varca la Soglia',
  'auth.login.seoDescription': 'Accedi a Grymwyrd e torna alla tua leggenda nel crepuscolo eterno.',
  'auth.login.eyebrow': 'Ritorna, Viandante',
  'auth.login.title': 'Varca la Soglia',
  'auth.login.blurb': 'Pronuncia il tuo nome e la parola segreta per rientrare nel crepuscolo eterno.',
  'auth.login.noPactYet': 'Nessun patto ancora?',
  'auth.login.forgeYourLegend': 'Forgia la tua leggenda',
  'auth.login.emailLabel': 'Email',
  'auth.login.emailPlaceholder': 'tu@grymwyrd.com',
  'auth.login.passwordLabel': 'Password',
  'auth.login.forgotPassword': 'Hai dimenticato la tua password?',
  'auth.login.submitBusy': 'Varcamento in corso…',
  'auth.login.submit': 'Entra',
  'auth.login.dividerOr': 'oppure',
  'auth.login.magicSentPrefix': 'Un link di accesso è in arrivo',
  'auth.login.magicSentTo': 'a',
  'auth.login.magicSentSuffix': '. Controlla la tua inbox.',
  'auth.login.emailMeSignInLink': 'Inviami un link di accesso',
  'auth.login.mockAuthPrefix': 'Autenticazione mock dev: qualsiasi email funziona. Usa',
  'auth.login.mockAuthOr': 'oppure',
  'auth.login.mockAuthSuffix': 'per ruoli elevati.',

  // ── RegisterPage ─────────────────────────────────────────────────────────
  'auth.register.errorDisplayNameRequired': 'Scegli il nome con cui la tua leggenda sarà raccontata.',
  'auth.register.errorEmailRequired': 'Un\'email è richiesta per sigillare il tuo patto.',
  'auth.register.errorEmailInvalid': 'Questa email non sembra corretta.',
  'auth.register.errorPasswordTooShort': 'La tua parola segreta deve avere almeno 8 caratteri.',
  'auth.register.errorMustBeAdult': 'Devi avere almeno 13 anni per unirti a Grymwyrd.',
  'auth.register.errorMustAcceptTerms': 'Devi accettare il patto (termini) per continuare.',
  'auth.register.errorIncomplete': 'Alcuni segni sul tuo patto sono incompleti. Vedi sotto.',
  'auth.register.seoTitle': 'Inizia la Tua Storia',
  'auth.register.seoDescription':
    'Crea un account Grymwyrd, incarni un avatar, e lascia che la tua storia diventi canone.',
  'auth.register.eyebrow': 'Esplora il Villaggio di Greywick',
  'auth.register.title': 'Inizia la Tua Storia',
  'auth.register.blurb': 'Ti svegli dai sogni eterici e apri gli occhi…',
  'auth.register.alreadyBound': 'Già legato al crepuscolo?',
  'auth.register.loginToExisting': 'Accedi al Tuo Account Esistente',
  'auth.register.displayNameLabel': 'Nome da mostrare',
  'auth.register.displayNamePlaceholder': 'Il Cavaliere Vuoto',
  'auth.register.displayNameHint': 'Questo nomina il tuo avatar pubblico e i tuoi contributi.',
  'auth.register.emailLabel': 'Email',
  'auth.register.emailPlaceholder': 'tu@grymwyrd.com',
  'auth.register.passwordLabel': 'Password',
  'auth.register.passwordPlaceholder': 'Almeno 8 caratteri',
  'auth.register.agreementsLegend': 'Accordi',
  'auth.register.adultConfirmPrefix': 'Dichiaro di avere',
  'auth.register.adultConfirmEmphasis': '13 anni o più',
  'auth.register.adultConfirmSuffix': '.',
  'auth.register.acceptPrefix': 'Accetto i',
  'auth.register.termsOfThePact': 'Termini del Patto',
  'auth.register.acceptSuffix': '.',
  'auth.register.submitBusy': 'Sigillatura del patto in corso…',
  'auth.register.submit': 'Emerge',
  'auth.register.dividerOr': 'oppure',
  'auth.register.mockAuthNote': 'Autenticazione mock dev: la registrazione persiste solo localmente. Nessuna email viene inviata.',
  'auth.register.lastUpdated': 'Ultimo aggiornamento {date}',

  // ── ResetPasswordPage ────────────────────────────────────────────────────
  'auth.reset.errorInvalidEmail': 'Inserisci l\'email legata al tuo patto.',
  'auth.reset.seoTitle': 'Ripristina la Tua Password',
  'auth.reset.seoDescription':
    'Hai dimenticato la tua password? Ti invieremo un link monouso; cliccalo per scegliere una nuova password.',
  'auth.reset.eyebrow': 'La Parola Perduta',
  'auth.reset.title': 'Ripristina la Tua Password',
  'auth.reset.blurb':
    'Sussurra la tua email e un link monouso sarà inviato nell\'oscurità. Seguilo indietro, e potrai impostare una nuova password.',
  'auth.reset.rememberedAfterAll': 'Alla fine l\'hai ricordata?',
  'auth.reset.loginToExisting': 'Accedi al Tuo Account Esistente',
  'auth.reset.successMessage':
    'Se esiste un account per {email}, un link monouso è stato inviato. Aprilo per accedere e impostare la tua nuova password — controlla la tua email e la cripta dello spam.',
  'auth.reset.sendToDifferentEmail': 'Invia a un\'email diversa',
  'auth.reset.emailLabel': 'Email',
  'auth.reset.emailPlaceholder': 'tu@grymwyrd.com',
  'auth.reset.submitBusy': 'Evocazione in corso…',
  'auth.reset.submit': 'Invia Link di Accesso',

  // ── SetPasswordPage ──────────────────────────────────────────────────────
  'auth.setPassword.errorTooShort': 'Scegli una password di almeno 8 caratteri.',
  'auth.setPassword.errorMismatch': 'Queste password non corrispondono.',
  'auth.setPassword.seoTitle': 'Imposta la Tua Password',
  'auth.setPassword.seoDescription': 'Scegli una nuova password per il tuo account Grymwyrd.',
  'auth.setPassword.eyebrow': 'Sigilla il Patto',
  'auth.setPassword.title': 'Imposta una Nuova Password',
  'auth.setPassword.blurb':
    'Sei collegato. Scegli una nuova password — potrai usarla la prossima volta insieme al link magico.',
  'auth.setPassword.ratherNot': 'Preferisci di no?',
  'auth.setPassword.skipForNow': 'Salta per ora',
  'auth.setPassword.successMessage': 'La tua password è impostata. Ti stiamo portando al tuo santuario…',
  'auth.setPassword.newPasswordLabel': 'Nuova password',
  'auth.setPassword.newPasswordPlaceholder': 'Almeno 8 caratteri',
  'auth.setPassword.confirmPasswordLabel': 'Conferma password',
  'auth.setPassword.confirmPasswordPlaceholder': 'Digitala di nuovo',
  'auth.setPassword.submitBusy': 'Sigillatura in corso…',
  'auth.setPassword.submit': 'Salva Password',
}
